import React, {useEffect, useRef} from 'react';
import './Sidebar.scss';
import {Poi} from '../../react-app-env';
import ItineraryPoiList from '../itinerarypoilist/ItineraryPoiList';
import Stack from '../stack/Stack';
import {StackApi, StackPage} from '../stack/Stack.types';
import SidebarHeader from './SidebarHeader';
import {SidebarPage} from './SidebarPage';
import PoiDetailsSidebarPage from '../poidetails/PoiDetailsSidebarPage';
import {useTrip} from '../context/TripContext';
import {useSelectedPoi} from '../context/SelectedPoiContext';

function Sidebar() {
  const trip = useTrip();
  const selectedPoi = useSelectedPoi();
  const prevSelectedPoiRef = useRef<Poi>(undefined);
  const stackApiRef = useRef<StackApi | null>(null);

  // Initialisation ---------------------------------------------------------------------------------

  // Initialise the stack with the itinerary page
  useEffect(() => {
    stackApiRef?.current?.push({
      id:   'itinerary-poi-list',
      node: <SidebarPage className="itinerary">
              <SidebarHeader
                  title={trip.title}
                  buttons={[]}/>
              <ItineraryPoiList/>
            </SidebarPage>
    });
  }, [trip]);

  // Propagate changes to the selected POI to the stack
  useEffect(() => {
    // Had a selected POI, but not anymore?
    if (prevSelectedPoiRef.current && !selectedPoi) {
      stackApiRef?.current?.pop();
    }
    // Existing POI updated?
    else if (selectedPoi && prevSelectedPoiRef.current?.id === selectedPoi?.id) {
      stackApiRef?.current?.replace(buildPoiDetailsStackPage(selectedPoi));
    }
    // New POI selected?
    else if (selectedPoi) {
      stackApiRef?.current?.rootPush(buildPoiDetailsStackPage(selectedPoi));
    }

    // Remember the most recently selected POI for the next render cycle
    prevSelectedPoiRef.current = selectedPoi;
  }, [selectedPoi]);

  function buildPoiDetailsStackPage(poi: Poi): StackPage {
    return {
      id:   'poi-details--' + poi.id,
      node: <PoiDetailsSidebarPage
                poi={poi}
                stackApi={stackApiRef?.current!}/>
    };
  }

  // Rendering ---------------------------------------------------------------------------------

  return (
      <div className="sidebar">
        <Stack ref={stackApiRef}/>
      </div>
  );
}

export default Sidebar;
